import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

import { Theme } from '@app/theme';
import { SquareButton } from '@app/core';
import { Modal } from './Modal';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    position: 'relative',
    overflow: 'visible',
    zIndex: 1,

    width: theme.maxContentWidth.largeModale,
    minHeight: 580,
    maxHeight: '90vh',

    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    borderWidth: 0,

    overlay: 'none',
    display: 'flex',
    alignItems: 'stretch',
  },
  leftPane: {
    width: theme.marginBase * 40,
    backgroundColor: theme.colors.grayBackground,
    padding: theme.marginBase * 4,
    maxHeight: '100%',
    overflowY: 'auto',
  },
  paneTitle: {
    ...theme.fonts.h4,
    color: theme.colors.inkPrimary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  closeIcon: {
    position: 'absolute',
    zIndex: 1,
    top: 0,
    right: -theme.height.small - theme.marginBase,
    [theme.media.tablet]: {
      right: 0,
    },
  },
  mainPane: {
    flex: 1,
    backgroundColor: theme.colors.white,
    width: theme.maxContentWidth.largeModale - theme.marginBase * 40,
  },
  paneContent: {
    padding: theme.marginBase * 4,
    flex: 1,
    overflow: 'auto',
    '& > *:last-child': {
      marginBottom: theme.marginBase * 4,
    },
  },
}));

interface Props {
  isOpen: boolean;
  onRequestClose: () => any;
  children?: React.ReactNode;
  paneClassName?: string;
  paneTitle?: string;
  paneContent?: React.ReactNode;
}

export const LargeModaleWithLeftPane = ({
  isOpen,
  onRequestClose,
  children,
  paneClassName,
  paneTitle,
  paneContent,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={classes.modal}
      overlayClassName={classes.overlay}
    >
      <SquareButton
        color="ink"
        icon="ri-close-line"
        className={classes.closeIcon}
        onClick={onRequestClose}
        variant="muted"
        overGray
      />
      {!!paneContent && (
        <div className={classNames(classes.leftPane, paneClassName)}>
          {!!paneTitle && <h2 className={classes.paneTitle}>{paneTitle}</h2>}
          {paneContent}
        </div>
      )}

      <div className={classes.mainPane}>{children}</div>
    </Modal>
  );
};
